<template>
  <s-modal
    v-model="showModalHandler"
    class="filters-modal"
    size="xl"
    :cancel-title="$t('general.clean-filters')"
    :ok-title="$t('actions.confirm')"
    @cancel="cleanFilters"
    @ok="applyFilters"
  >
    <b-container fluid>
      <b-row>
        <b-col md="12" lg="8" class="pl-0 pr-0 pr-lg-1">
          <b-container fluid>
            <b-row class="filters-modal__bordered-container">
              <b-col cols="12">
                <label>
                  {{ $t('engineering.sample-situation.label') }}
                </label>
              </b-col>
              <b-col sm="12" md="6" lg="4">
                <b-form-checkbox v-model="filters.sampleSituation.normal">
                  {{ $t('engineering.sample-situation.normal-samples') }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="12" md="6" lg="4">
                <b-form-checkbox v-model="filters.sampleSituation.withAlarm">
                  {{ $t('engineering.sample-situation.samples-with-alarm') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <label>
                {{ $t('entities.lot')}}
              </label>
              <s-multiselect
                :proxy-binds="{
                  options: teste2,
                }"
                v-model="teste"
              />
            </b-row>
            <b-row class="filters-modal__bordered-container mt-2">
              <b-col cols="12">
                <label>
                  {{ $t('engineering.test-information.label') }}
                </label>
              </b-col>
              <b-col sm="12" md="6" lg="4">
                <b-form-checkbox v-model="filters.sampleSituation.main">
                  {{ $t('engineering.test-information.main-tests') }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="12" md="6" lg="4">
                <b-form-checkbox v-model="filters.sampleSituation.complementary">
                  {{ $t('engineering.test-information.complementary-tests') }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="12" md="6" lg="4">
                <b-form-checkbox v-model="filters.sampleSituation.additional">
                  {{ $t('engineering.test-information.additional-tests') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col md="12" lg="4" class="pr-0 pl-0 pl-lg-1 mt-2 mt-lg-0">
          <b-container fluid class="filters-modal__bordered-container">
            <b-row>
              <b-col cols="12" align-self="end">
                <label>
                  {{ $t('engineering.sample-date') }}
                </label>
              </b-col>
              <b-col
                v-for="radio in sampleDateRadios"
                cols="12"
                :key="radio.label"
              >
                <b-form-radio
                  class="my-1"
                  :value="radio.value"
                  v-model="filters.sampleDate.period"
                >
                  {{ radio.label }}
                </b-form-radio>
              </b-col>
              <b-col
                lg="6"
                md="12"
                class="mt-3"
              >
                <label>
                  {{ $t('fields.general.initial-date') }}
                </label>
                <s-input-date-picker/>
              </b-col>
              <b-col
                md="12"
                lg="6"
                class="mt-3"
              >
                <label>
                  {{ $t('fields.general.final-date') }}
                </label>
                  <s-input-date-picker/>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="12" class="mt-2">
          <b-row class="filters-modal__bordered-container">
            <b-col cols="12">
              <label>
                {{ $t('engineering.oil-samples') }}
              </label>
            </b-col>
            <b-col sm="12" md="6" lg="3">
              <b-form-checkbox>
                {{ $t('enums.sample-type.used') }}
              </b-form-checkbox>
            </b-col>
            <b-col sm="12" md="6" lg="3">
              <b-form-checkbox>
                {{ $t('enums.sample-type.new') }}
              </b-form-checkbox>
            </b-col>
            <b-col sm="12" md="6" lg="3">
              <b-form-checkbox>
                {{ $t('enums.sample-type.recondicioned') }}
              </b-form-checkbox>
            </b-col>
            <b-col sm="12" md="6" lg="3">
              <b-form-checkbox>
                {{ $t('enums.sample-type.regenerated') }}
              </b-form-checkbox>
            </b-col>
            <b-col sm="12" md="6" lg="3">
              <b-form-checkbox>
                {{ $t('enums.sample-type.undefined') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col
          cols="12"
          class="filters-modal__columns-exhibition-title py-2"
        >
          <label class="mb-0">
            {{ $t('fields.general.columns-display') }}
          </label>
        </b-col>
      </b-row>
      <b-row class="mt-4 mb-2 filters-modal__table">
        <b-row class="filters-modal__table-header">
          <b-col cols="2" class="text-center">
            <label>
              {{ $t('general.sort') }}
            </label>
          </b-col>
          <b-col cols="7">
            <label>
              {{ $t('general.columns') }}
            </label>
          </b-col>
          <b-col cols="3" class="text-center">
            <label>
              {{ $t('fields.general.display-column') }}
            </label>
          </b-col>
        </b-row>
        <b-col cols="12" id="flip-list-demo" class="demo filters-modal__columns-list">
          <transition-group name="flip-list">
            <b-row
              :key="column.name"
              v-for="(column, index) in columns"
              class="filters-modal__columns-item list-item"
            >
              <b-col cols="2" class="text-center">
                <b-button
                  @click="moveUp(column, index)"
                  size="sm"
                  variant="outline-primary"
                  v-if="firstOrLast(index)"
                >
                  <i
                    aria-hidden="true"
                    class="fas fa-chevron-up"
                  />
                </b-button>
                <b-button
                  @click="moveDown(column, index)"
                  size="sm"
                  variant="outline-primary"
                  v-if="firstOrLast(index, columns)"
                >
                  <i
                    class="fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </b-col>
              <b-col cols="7">
                {{ column.name }}
              </b-col>
              <b-col cols="3" class="text-center">
                <b-form-checkbox v-model="column.show"/>
              </b-col>
            </b-row>
          </transition-group>
        </b-col>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    teste: [],
    teste2: [],
    filters: {
      sampleSituation: {
        normal: false,
        withAlarm: false,
      },
      lot: [],
      testInformation: {
        main: false,
        complementary: false,
        additional: false,
      },
      oilSample: {
        used: false,
        new: false,
        recondicioned: false,
        regenerated: false,
      },
      sampleDate: {
        period: null,
        initialDate: null,
        finalDate: null,
      },
    },
    selectedPeriod: 30,
    columns: [
      {
        name: 'Coluna 1',
        show: false,
      },
      {
        name: 'Coluna 2',
        show: false,
      },
      {
        name: 'Coluna 3',
        show: false,
      },
      {
        name: 'Coluna 4',
        show: false,
      },
      {
        name: 'Coluna 5',
        show: false,
      },
      {
        name: 'Coluna 7',
        show: false,
      },
      {
        name: 'Coluna 8',
        show: false,
      },
      {
        name: 'Coluna 9',
        show: false,
      },
    ],
  }),
  computed: {
    showModalHandler: {
      get() {
        return this.showModal;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sampleDateRadios() {
      return [
        {
          label: this.$t('fields.general.last-month'),
          value: 30,
        },
        {
          label: this.$t('fields.general.last-six-months'),
          value: 180,
        },
        {
          label: this.$t('fields.general.last-year'),
          value: 360,
        },
        {
          label: this.$t('fields.general.custom'),
          value: null,
        },
      ];
    },
  },
  methods: {
    firstOrLast(index, list) {
      return list ? index !== list.length - 1 : index !== 0;
    },
    cleanFilters() {
      this.$emit('clean-filters');
    },
    applyFilters() {
      this.$emit('apply-filters');
    },
    moveUp(item, index) {
      const previousIndex = index - 1;
      const previousItemCopy = cloneDeep(this.columns[previousIndex]);
      this.$set(this.columns, previousIndex, item);
      this.$set(this.columns, index, previousItemCopy);
    },
    moveDown(item, index) {
      const nextIndex = index + 1;
      const nextItemCopy = cloneDeep(this.columns[nextIndex]);
      this.$set(this.columns, nextIndex, item);
      this.$set(this.columns, index, nextItemCopy);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .flip-list-move
    transition: transform .5s

  .filters-modal
    &__table
      overflow-y: auto
    &__table-header
      width: 100%
      display: inline-flex
      position: sticky
      top: 0
      z-index: 1
      background-color: var(--color-table-body-accent-bg)
      height: 35px
      align-items: center
      margin-left: 0
      label
        margin-bottom: 0
    &__main-columns
      height: 100%
    &__bordered-container
      height: 100%
      padding-top: 10px
      padding-bottom: 10px
      border: 1px solid var(--color-border-regular)
      border-radius: 5px
    &__columns-exhibition-title
      background-color: var(--color-table-header-bg)
    &__columns-list
      max-height: 40vh
    &__columns-item
      min-width: 600px
      height: 35px
      display: flex
      align-items: center
      background-color: var(--color-background-light)
      &:nth-child(2n)
        background-color: var(--color-table-body-accent-bg)
</style>
